<template>
  <div class="kyoutei-end-date edit-item" v-if="editingData">

    <div class="head"><b>当該協定の<br>有効期間の終了日</b></div>
    <div class="data">
      <date-picker v-model="editingData.kyoutei_end_date" :clearable="false"
      :error="getError(editingData, 'kyoutei_end_date')" :disabled="disabled"></date-picker>
      <p class="current-data" v-if="currentData?.kyoutei_end_date">{{ currentData.kyoutei_end_date }}</p>
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();
    return {
      getError
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
